import { readOnlyStyles } from '../styles'

export const InputStyle = (theme, readOnly, datePickerProps, isDisabled) => {
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    return {
        bg: 'inputBg',
        borderRadius: readOnly || isDisabled ? '0px' : '8px',
        px: 5,
        py: 4,
        fontSize: 3,
        border: 'none',
        boxSizing: 'border-box',
        borderStyle: 'solid',
        borderColor: 'inputBorder',
        borderWidth: readOnly || isDisabled ? '2px' : '1px',
        height: 50,
        fontFamily: fontFamily,
        color: readOnly || isDisabled ? theme.colors.inputPlaceholder : theme.colors.blackLabelfont,
        background: readOnly || isDisabled ? theme.colors.Gray125 : 'transparent',
        '::placeholder': {
            textAlignLast: 'left',
            textOverflow: 'ellipsis',
            whiteSpace: 'no-wrap',
            lineHeight: '140%',
            fontWeight: '400',
            overflow: 'hidden',
            fontSize: '14px',
            color: theme.colors.grayLabelPlaceholder,
        },

        '&:hover': {
            borderColor: 'inputBorder',
        },

        '&:focus': {
            boxShadow: `0px 0px 0px 3px ${theme.colors.inputShadow}`,
            borderColor: readOnly ? 'inputBorder' : theme.colors.secondaryColor,
        },
        outline: 'none',
        ...datePickerProps,
        ...(readOnly && readOnlyStyles(theme)),
    }
}
